"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalId = void 0;
const uuid_1 = require("uuid");
const local_data_1 = require("../helpers/local-data");
class LocalId {
    constructor() {
        Object.defineProperty(this, "_id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.create();
    }
    create() {
        if (!local_data_1.LocalData.hasStorage || this.hasId()) {
            return;
        }
        this._id = (0, uuid_1.v4)();
        local_data_1.LocalData.writeStorage(local_data_1.StorageKeys.localId, {
            id: this._id,
        });
    }
    getId() {
        if (this._id) {
            return this._id;
        }
        const userData = local_data_1.LocalData.readStorage(local_data_1.StorageKeys.localId);
        if (userData === null || userData === void 0 ? void 0 : userData.id) {
            this._id = userData.id;
        }
        return userData === null || userData === void 0 ? void 0 : userData.id;
    }
    hasId() {
        return this.getId() !== undefined;
    }
}
exports.LocalId = LocalId;
